module.exports = __webpack_public_path__ + "assets/img/middle-bg.4ebd7533.png";